import { CoralMark } from './CoralMark.jsx';

export function Wordmark({ size = 28 }) {
  return (
    <div
      className="font-heading"
      style={{ fontSize: size, letterSpacing: '0.02em', lineHeight: 1 }}
    >
      <span style={{ color: 'var(--text)' }}>Tank</span>
      <span style={{ color: 'var(--cyan)' }}>Sensei</span>
      <CoralMark size={Math.round(size * 0.82)} style={{ marginLeft: 8, opacity: 0.95 }} />
    </div>
  );
}
